import React, { Component } from 'react'
import {
    Link,
    Redirect
} from 'react-router-dom'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import ConfirmButton from "../../common/button/confirmbutton.component.jsx"
import LabelHelper from "../../common/LabelHelper.jsx";


const messages = defineMessages({
    "name_placeholder": {
        id: 'payment_term.form.edit.name_placeholder',
        defaultMessage: 'Name of the payment term',
    },
    "save_btn": {
        id: 'payment_term.form.edit.save_btn',
        defaultMessage: 'Save',
    },
})

class PaymentTermEditForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            id: '',
            name: '',
            dueType: 'fixed-days',
            dueInNumberOfDays: 0,
            dueByDayOfMonth: 0,
            minimumDaysToPay: 0,
            deleteButton: '',
        }

        this.submit = this.submit.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
        this.remove = this.remove.bind(this)
    }

    componentDidMount() {
        const term = this.props.paymentTerm
        if (term && term.id) {
            this.loadPaymentTerm(term)
        }
    }

    loadPaymentTerm(term) {
        const deleteButton = <ConfirmButton identifier={term.attributes.name} onClick={this.remove} className="btn btn-danger">
            <FormattedMessage
                id="payment_term.form.edit.delete_btn"
                defaultMessage="Delete payment term"
            />
        </ConfirmButton>
        this.setState({
            id: term.id,
            name: term.attributes.name,
            dueType: term.attributes.dueType,
            dueInNumberOfDays: term.attributes.dueInNumberOfDays,
            dueByDayOfMonth: term.attributes.dueByDayOfMonth,
            minimumDaysToPay: term.attributes.minimumDaysToPay,
            term: term,
            deleteButton: deleteButton,
        })
    }

    remove(event) {
        AppContext.getApiClient().delete('/payment-terms/' + this.state.id).then(response => {
            if (!response.error) {
                this.setState({ formStatus: <Redirect to={{ pathname: '/payment-terms/listing' }} /> })
            }
        })
        event.preventDefault()
    }

    save() {
        if (this.state.term && this.state.id) {
            let updates = {}
            const allowedFields = [
                "name",
                "dueType",
                "dueInNumberOfDays",
                "dueByDayOfMonth",
                "minimumDaysToPay",
            ]
            for (let i = 0; i < allowedFields.length; i++) {
                let field = allowedFields[i]
                if (this.state.term.attributes[field] != this.state[field]) {
                    updates[field] = this.state[field]
                }
            }
            if (this.state.organization) {
                updates.organization = this.state.organization
            }
            return AppContext.getApiClient().patch('/payment-terms/' + this.state.id, updates)
        } else {
            return AppContext.getApiClient().post('/payment-terms', {
                "name": this.state.name,
                "dueType": this.state.dueType,
                "dueInNumberOfDays": parseInt(this.state.dueInNumberOfDays),
                "dueByDayOfMonth": parseInt(this.state.dueByDayOfMonth),
                "minimumDaysToPay": parseInt(this.state.minimumDaysToPay),
            })
        }
    }

    submit(event) {
        event.preventDefault()
        this.save().then(response => {
            if (!response.error) {
                this.setState({ formStatus: <Redirect to={{ pathname: '/payment-terms/listing' }} /> })
            }
        })
        event.preventDefault()
    }

    handleFocus(event) {
        event.target.select()
    }

    handleFormChange(event) {
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        if (["dueInNumberOfDays", "dueByDayOfMonth", "minimumDaysToPay"].includes(name)) {
            value = parseInt(value)
        }
        this.setState({
            [name]: value
        });
    }

    render() {
        const monthDays = []
        for (let i = 1; i < 29; i++) {
            monthDays.push(i)
        }
        monthDays.push(31)
        return (
            <form onSubmit={this.submit}>
                <div className="row ui-has-modules">
                    <div className="col-12 ui-module">
                        <div className="form-group row mb-0">
                            <label className="col-2 col-form-label text-align-right" htmlFor="name">
                                <FormattedMessage
                                    id="payment_term.form.edit.name_label"
                                    defaultMessage="Name"
                                />
                            </label>
                            <div className="col-10 mb-3">
                                <input
                                    name="name"
                                    value={this.state.name}
                                    onChange={this.handleFormChange}
                                    id="name"
                                    type="text"
                                    className="form-control"
                                    placeholder={this.props.intl.formatMessage(messages['name_placeholder'])}
                                />
                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="payment_term.form.edit.name_description"
                                        defaultMessage="This name will show on each invoice"
                                    />
                                </small>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-2 col-form-label text-align-right" htmlFor="lastName">
                                <FormattedMessage
                                    id="payment_term.form.edit.details_label"
                                    defaultMessage="Details"
                                />
                            </label>
                            <div className="col-10">
                                <select name="dueType"
                                    value={this.state.dueType}
                                    onChange={this.handleFormChange}
                                    id="dueType"
                                    className="form-control"
                                >
                                    {["fixed-days", "day-of-month"].map(type => <option key={type} value={type}>
                                        {LabelHelper.getPaymentTermDueTypeLabel(this.props.intl, type)}
                                    </option>)}
                                </select>
                                {this.state.dueType === 'fixed-days' ? <div className={'w-100 mt-3'}>
                                    <FormattedMessage
                                        id="payment_term.form.edit.fixed_days_label"
                                        defaultMessage="{count} days"
                                        values={{
                                            count: <input
                                                onFocus={this.handleFocus}
                                                style={{ width: '4em' }}
                                                className="form-control d-inline"
                                                min={0}
                                                type={'number'}
                                                value={this.state.dueInNumberOfDays}
                                                onChange={this.handleFormChange}
                                                name={'dueInNumberOfDays'}
                                            />
                                        }}
                                    />
                                </div> : <div className={'w-100 mt-3'}>
                                        <p className={'mb-1'}>
                                            <FormattedMessage
                                                id="payment_term.form.edit.day_of_month_label"
                                                defaultMessage="{day} day of month"
                                                values={{
                                                    day: <select className="custom-select w-auto" name={'dueByDayOfMonth'} value={this.state.dueByDayOfMonth} onChange={this.handleFormChange}>
                                                        {monthDays.map(day => <option key={day} value={day}>{LabelHelper.getDayOfMonthLabel(this.props.intl, day || 0)}</option>)}
                                                    </select>
                                                }}
                                            />
                                        </p>
                                        <p className={'mb-0'}>
                                            <FormattedMessage
                                                id="payment_term.form.edit.minimum_days_to_pay_label"
                                                defaultMessage="Due the next month if issued within {count} days of the due date"
                                                values={{
                                                    count: <input
                                                        onFocus={this.handleFocus}
                                                        style={{ width: '4em' }}
                                                        className="form-control d-inline"
                                                        min={0}
                                                        type={'number'}
                                                        value={this.state.minimumDaysToPay}
                                                        onChange={this.handleFormChange}
                                                        name={'minimumDaysToPay'}
                                                    />
                                                }}
                                            />
                                        </p>
                                    </div>}
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        {this.state.formStatus}
                    </div>
                    <div className="col-12 ui-module">
                        <div className="row">
                            <div className="col-6">
                                {this.state.deleteButton}
                            </div>
                            <div className="col-6 text-align-right">
                                <Link to="/payment-terms/listing" className="btn btn-light">
                                    <FormattedMessage
                                        id="payment_term.form.edit.cancel_btn"
                                        defaultMessage="Cancel"
                                    />
                                </Link>
                                &nbsp;
                                &nbsp;
                                <input type="submit" value={this.props.intl.formatMessage(messages['save_btn'])} className="btn btn-primary" />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default injectIntl(PaymentTermEditForm)


// WEBPACK FOOTER //
// ./src/payment-term/form/edit.component.jsx